import Vue from 'vue'
import { getProductImageUrl } from 'util/turnto-utils'
import { isMobileDevice } from 'util/browser-utils'
import { truncateText } from 'util/text-utils'
import { openFacebookShare, openPinterestShare, openTwitterShare }
  from 'services/social-sharing-service'
import tileMixin from 'layouts/masonry/tile-mixin'
import PinboardComment from './pinboard-comment'
import ProductImage from 'objects/product-image/product-image'
import RatingStars from 'components/rating/rating-stars'

import withRender from './comments-pinboard-item.html'
import './comments-pinboard-item.scss'

export default withRender(Vue.extend({

  data() {
    return {
      // TT-11794 - showActions is to help hold actions visible when going to focus on button
      // Also used to help move the actions outside of the anchor tag.
      showActions: false,
      commentsForDisplay: []
    }
  },
  props: {
    commentMaxLength: {
      type: Number,
      required: true
    },
    // if passed, will render the "see x more comments" section
    commentsCount: { type: Number },
    hoverTitleMaxLength: {
      type: Number,
      required: true
    },
    item: {
      type: Object,
      required: true
    },
    // For pinboard teaser where it should display 1 or 2 comments depending on number of lines
    linesLimit: Number,
    showReviewStars: Boolean,
    showSocialSharing: Boolean,
    titleMaxLength: {
      type: Number,
      required: true
    },
    // hard-coded as it is in 4.3.  May make a config option as we have for other widgets
    truncateAllowance: {
      type: Number,
      default: 9
    },
    userNameMaxLength: {
      type: Number,
      required: true
    }
  },
  mixins: [tileMixin],
  components: {
    'tt-pinboard-comment': PinboardComment,
    'tt-product-image': ProductImage,
    'tt-rating-stars': RatingStars
  },
  computed: {
    displayReviewStars() {
      return this.item.reviewCount > 0 && this.showReviewStars
    },
    hoverTitle() {
      const truncated = truncateText(this.item.title, this.hoverTitleMaxLength)
      return truncated ? `${truncated}&hellip;` : this.item.title
    },
    isOnMobile() {
      return isMobileDevice()
    },
    title() {
      const truncated = truncateText(this.item.title, this.titleMaxLength)
      return truncated ? `${truncated}&hellip;` : this.item.title
    },
    productLink() {
      // TODO: needs to be a translink.  Not sure yet how handling in v5
      return this.item.url
    },
    seeMoreText() {
      const count = this.commentsCount
      if (count !== undefined) {
        return this.$msg('commentsPinboardTeaser.moreComments', [count], count)
      }
      return null
    },
    tileWidth() {
      return this.tileAttributes.width
    }
  },
  methods: {
    commentExpanded() {
      // one of the child pinboard comments expanded, so calling the tileMixin to notify the layout
      // that this item has expanded
      this.tileHeightChanged()
    },
    onShowActions() {
      this.showActions = true
    },
    onHideActions() {
      this.showActions = false
    },
    openFacebookWindow() {
      openFacebookShare(this.item.url)
    },
    openPinterestWindow() {
      openPinterestShare(this.item.url, getProductImageUrl(this.item), this.item.title)
    },
    openTwitterWindow() {
      openTwitterShare(this.item.url, this.item.title)
    }
  },
  created() {
    this.commentsForDisplay = this.item.comments
  },
  mounted() {
    if (this.linesLimit) {
      // The code below is not ideal, especially looking up an element in the child component
      // by it's class name. Would like to have better way to handle these requirements.
      // Determining if we need to hide a comment.
      // The rules go as follows:
      // 1) If the 1st comment is > linesLimit lines, just show it (hide the 2nd)
      // 2) If the 1st comment is <=linesLimit lines, and the 2nd comment is >linesLimit lines,
      //    show it and hide the first
      // 3) That should leave the final option as both comments having <=linesLimit lines,
      //    in which case we will show both.
      const commentTextElements = this.$el.querySelectorAll('.tt-c-pinboard-comment__text')
      const numberOfLines = []
      // should only be two comments, but making sure at least 2
      if (commentTextElements.length >= 2) {
        for (let i = 0; i < commentTextElements.length; i++) {
          // Checking number of lines the comment takes with a method described here:
          // http://rickeyre.ca/2014/04/15/number-of-lines-of-text.html
          const item = commentTextElements[i]
          item.style.display = 'inline'
          numberOfLines.push(item.getClientRects().length)
          item.style.display = null
        }
        if (numberOfLines[0] > this.linesLimit) {
          this.commentsForDisplay = this.item.comments.slice(0, 1)
        } else if (numberOfLines[1] > this.linesLimit) {
          this.commentsForDisplay = this.item.comments.slice(1, 2)
        }
      }
    }
    // from tileMixin
    if (this.isTile) {
      this.isReady = true
    }
  },
  watch: {
    tileWidth() {
      // watching for the tile width that comes from the mixin.  This is changed when the
      // layout sets the width. When changed, setting the height, then setting isReady to true
      // so that the positioning of the tiles gets redrawn
      if (this.isTile) {
        this.$refs.productImage.$el.style.height = `${this.tileWidth}px`
        this.$nextTick(() => {
          this.isReady = true
        })
      }
    }
  }
}))



// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--1!(webpack)-strip-block!./src/components/pinboard/comments-pinboard-item.ts